/**
 * Web/Storybook용 useInstanceId mock
 * useRoute 의존성 없이 기본값 반환
 */
export const useInstanceId = (): string => 'default';
